import { stateGo } from 'redux-ui-router';
import { datesForWeek } from 'utils';
import { fetchProduct, selectProduct, selectWeeks } from 'logic/product';
import { completionsFetch } from 'logic/completions';

import {
  changeSubscription,
  selectMember,
  selectSubscription,
  selectSubscriptionHasStarted,
  startSubscription,
  restartSubscription,
} from 'logic/member';

export const Program = {
  template: `
    <div class="program-container">
      <div ng-if="$ctrl.product && $ctrl.subscription">
        <ui-view autoscroll="false"></ui-view>
        <program-start-modal
          subscription="$ctrl.subscription"
          dates-for-week="$ctrl.datesForWeek"
          on-submit="$ctrl.startSubscription(data)"
          ng-if="!$ctrl.hasStarted || ($ctrl.product.daysElapsed < 0)">
        </program-start-modal>
        <program-restart-modal
          subscription="$ctrl.subscription"
          weeks="$ctrl.weeks"
          on-submit="$ctrl.restartSubscription(data)"
          ng-if="$ctrl.hasStarted && ($ctrl.product.daysElapsed >= 0)">
        </program-restart-modal>
      </div>
    </div>`,

  controller($ngRedux, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        this.fetchProduct(this.voomeProductId, this.subscription.startedAt);
        this.completionsFetch(this.member.id, this.voomeProductId);
        this.datesForWeek = datesForWeek();
      },

      $onDestroy() {
        this.disconnect();
      },

      mapState(state) {
        const { member, product, router } = state;
        const { voomeProductId } = router.currentParams;

        return {
          voomeProductId,
          hasStarted: selectSubscriptionHasStarted(member, voomeProductId),
          member: selectMember(member),
          product: selectProduct(product),
          subscription: selectSubscription(member, voomeProductId),
          weeks: selectWeeks(product),
        };
      },

      mapDispatch() {
        return {
          changeSubscription,
          completionsFetch,
          fetchProduct,
          startSubscription,
          stateGo,
          restartSubscription,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Program/Program.js